import {configureStore} from "@reduxjs/toolkit";
import utilityReducer from "./utility-slice"

const store = configureStore({
    // other store configuration options...
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
    reducer: {
        utility: utilityReducer,
    }
});

export default store;
